import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { RefreshReactQuery } from "../../../../constants/AppConstants";
import { useNotification } from "../../../notification.hook";
import {
  DATA_SAVED_SUCCESS_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../../../constants/Dictionary";
import { UpdateGradesConfigRequest } from "../../../../types/api/configurations.type";
import { useEffect } from "react";
import ConfigurationsGradesService from "../../../../services/api/configurations/ConfigurationsGrades.service";

const MANAGE_CONFIG_GRADES_KEY = "get-config-grades";

export const useManageGrades = (configYear: number) => {
  const { notification } = useNotification();
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: [MANAGE_CONFIG_GRADES_KEY, configYear],
    queryFn: () => ConfigurationsGradesService.list(),
    staleTime: RefreshReactQuery.MODERATE,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);

  return { data, isFetching, refetch };
};

export const useUpdateManageGrades = () => {
  const { notification } = useNotification();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: ["update-manage-grades"],
    mutationFn: (result: UpdateGradesConfigRequest) =>
      ConfigurationsGradesService.update(result),
    onSuccess: async () => {
      notification.success(DATA_SAVED_SUCCESS_LABEL, undefined, "toast");
      await queryClient.invalidateQueries({
        queryKey: [MANAGE_CONFIG_GRADES_KEY],
      });
    },
    onError: (error) => {
      console.error(`error updating grades config: ${error}`);
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    },
  });

  return { mutate, mutateAsync, isPending };
};
